import PaneHeadline from './PaneHeadline';

export default PaneHeadline;
